import { apiClient } from "../../shared/api/httpClient";

export async function getUser(userId) {
  const response = await apiClient.get(`/users/${userId}/`);
  return response.data;
}

export async function getFollowingUsers(userId) {
  const response = await apiClient.get(`/users/${userId}/following/`);
  return response.data;
}

export async function getFollowerUsers(userId) {
  const response = await apiClient.get(`/users/${userId}/followers/`);
  return response.data;
}

export async function setUserFollow(userId, following) {
  const response = await apiClient({
    method: following ? "post" : "delete",
    url: `/users/${userId}/follow/`,
  });
  return response.data;
}
